export default __webpack_public_path__ + "static/media/copy-to-clipboard.a75fc704.svg";